import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { PlantService } from 'src/app/services/plant.service';
import { AddplantService } from 'src/app/services/addplant.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Plant } from 'src/app/model/plant.model';

@Component({
  standalone: false,
  selector: 'app-add-new-plant-trees',
  templateUrl: './add-new-plant-trees.component.html',
  styleUrls: ['./add-new-plant-trees.component.scss'],
})
export class AddNewPlantTreesComponent
  implements OnInit, OnDestroy, DoCheck, AfterViewInit {
  @ViewChild('content', { static: true }) modalContent: ElementRef;
  @ViewChild('uploadImages', { static: false }) uploadImages: ElementRef;
  @ViewChild('plant-details', { static: false }) plantdetailsbutton: ElementRef;

  public mainPlant = new Plant();

  activeIds: string[] = ['form_row_01', 'form_row_02', 'form_row_03'];
  images = [];
  afterConvertFile: any = [];

  imageChangedEvent: any = '';
  croppedImage: any = '';
  currentProcessingImg: any = 0;
  imgId: any = 0;
  finalImageList: any = [];
  prakList: any = [];
  photoData: any = {};
  croppedImageFile: any = '';
  selectedDocumentFile: any;
  public formData: any;
  uploadData: any;

  private subscriptions = new Subscription();
  public accordianIcon = '../../../assets/images/icons/chevron_up.svg';

  myForm = new FormGroup({
    VegetationName: new FormControl(),
    Species: new FormControl(),
    ParkId: new FormControl(),
    file: new FormControl(),
    VegetationPhotos: new FormControl(),
    VegetationNotes: new FormArray([]),
    createdBy: new FormControl(),
    isActive: new FormControl(),
  });

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private plantService: PlantService,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private addplantService: AddplantService
  ) {
    this.myForm = this.formBuilder.group({
      VegetationName: ['', [Validators.required, Validators.maxLength(100)]],
      Species: ['', [Validators.required]],
      ParkId: ['', [Validators.required]],
      file: [''],
      VegetationPhotos: [''],
      VegetationNotes: this.formBuilder.array([this.newNotes()]),
      createdBy: '',
      isActive: true,
    });

    localStorage.setItem('expandNavLand', 'true');
    const route = this.sideNavService.routingChunks({
      name: 'Landscaping and Vegetation',
      subNav: '0',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(route);

    /* setTimeout(() => {
      this.activeIds = [
        'ngb-panel-0',
        'ngb-panel-1',
        'ngb-panel-2',
        'ngb-panel-3',
        'ngb-panel-4',
        'ngb-panel-5',
        'ngb-panel-6',
        'ngb-panel-7',
        'ngb-panel-8',
        'ngb-panel-9',
        'ngb-panel-10',
      ];
    }, 1000); */
  }

  VegetationNotes(): FormArray {
    return this.myForm.get('VegetationNotes') as FormArray;
  }

  newNotes(): FormGroup {
    return this.formBuilder.group({
      headline: ['', Validators.required],
      description: ['', Validators.required],
    });
  }

  newPhotos(): FormGroup {
    return this.formBuilder.group({
      photoData: [],
    });
  }

  addMore(): void {
    this.VegetationNotes().push(this.newNotes());
  }

  removeBlock(i: number) {
    this.VegetationNotes().removeAt(i);
  }

  ngAfterViewInit(): void { }

  ngOnInit(): void {
    // this.mainPlant.vegetationName = "frrr";
    this.mainPlant.ParkId = '';

    // let inputElement: HTMLElement = this.plantdetailsbutton.nativeElement as HTMLElement;
    // inputElement.click();

    /* setTimeout(() => {
      this.activeIds = [
        'ngb-panel-0',
        'ngb-panel-1',
        'ngb-panel-2',
        'ngb-panel-3',
        'ngb-panel-4',
        'ngb-panel-5',
        'ngb-panel-6',
        'ngb-panel-7',
        'ngb-panel-8',
        'ngb-panel-9',
        'ngb-panel-10',
      ];
    }, 1000); */
    localStorage.removeItem('expandNav');
    this.getParkDetails();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavLand');
    this.subscriptions.unsubscribe();
  }

  ngDoCheck(): void {
    // setTimeout(() => {
    //   let inputElement: HTMLElement = this.plantdetailsbutton.nativeElement as HTMLElement;
    //   inputElement.click();
    // }, 1000);
    // console.log("do check");
  }

  onFileChange(event: any, file?: any) {
    if (event.target.files && event.target.files[0]) {
      const fileItem = event.target.files[0];
      console.log(fileItem);

      var filesAmount = event.target.files.length;

      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[i]);

        reader.onload = (innerEvent: any) => {
          // this.imgId = this.imgId + 1;
          this.images.push({
            // imgId: this.imgId,
            imgBase64: innerEvent.target.result,
            imgFile: event.target.files[i],
            cropped: false,
          });

          this.myForm.patchValue({
            VegetationPhotos: this.images,
          });
        };
      }
      console.log(this.images);
    }
  }

  onBulkUploadChange(bulkevent: any) {
    // let fileItem = bulkevent.target.files[0];
    // let bulkfile1: File = fileItem;
    // this.selectedDocumentFile = bulkfile1;
    // this.formData = new FormData();
    // this.formData.append('file', this.selectedDocumentFile, this.selectedDocumentFile.name);

    const fileItem = bulkevent.target.files[0];
    const ext = bulkevent.target.files[0].name.match(/\.(.+)$/)[1];
    const extList = ['csv', 'xlsx', 'xls'];

    if (bulkevent.target.files && extList.indexOf(ext) !== -1) {
      const file: File = fileItem;
      const reader = new FileReader();
      reader.readAsDataURL(bulkevent.target.files[0]);

      reader.onload = (e: any) => {
        const uploadData = new FormData();
        uploadData.append('uplodedfile', fileItem, fileItem.name);
        uploadData.append('claAdminId', localStorage.getItem('claAdminId'));

        this.plantService.bulkUploadFile(uploadData).subscribe((res) => {
          console.log(res);
          this.router.navigate(['/listplants/']);
        });
      };
    }
  }

  onSubmit(): void {
    this.uploadData = new FormData();

    this.myForm.patchValue({
      createdBy: localStorage.getItem('claAdminId'),
      isActive: true,
    } as any);

    for (let i = 0; i <= this.images.length - 1; i++) {
      this.afterConvertFile.push(
        this.dataURLtoFile(
          this.images[i].imgBase64,
          this.images[i].imgFile.name
        )
      );
    }

    let imgFileProperties = this.afterConvertFile.map(
      (img: any, filename: any) => {
        let properties = {
          photoData: img,
          vegetationPhotoName: img.name,
        };
        // this.uploadData.append('photoData', img);
        // this.uploadData.append('vegetationPhotoName', img.name);
        return properties;
      }
    );

    console.log(imgFileProperties);

    const uploadData = new FormData();

    for (let i = 0; i <= imgFileProperties.length - 1; i++) {
      uploadData.append(
        'VegetationPhotos[' + i + '].photoData',
        imgFileProperties[i].photoData
      );
      uploadData.append(
        'VegetationPhotos[' + i + '].vegetationPhotoName',
        imgFileProperties[i].vegetationPhotoName.split('?').at(0)
      );
    }
    for (let i = 0; i <= this.myForm.value.VegetationNotes.length - 1; i++) {
      uploadData.append(
        'VegetationNotes[' + i + '].headline',
        this.myForm.value.VegetationNotes[i].headline
      );
      uploadData.append(
        'VegetationNotes[' + i + '].description',
        this.myForm.value.VegetationNotes[i].description
      );
    }
    uploadData.append('VegetationName', this.myForm.value.VegetationName);
    uploadData.append('Species', this.myForm.value.Species);
    uploadData.append('ParkId', this.myForm.value.ParkId);
    uploadData.append('CreatedBy', localStorage.getItem('claAdminId'));
    uploadData.append('IsActive', 'true');
    // uploadData.append('VegetationNotes', this.myForm.value.VegetationNotes);
    console.log(uploadData);

    this.myForm.patchValue({
      VegetationPhotos: imgFileProperties,
    });

    console.log(this.myForm.value);

    if (this.myForm.valid) {
      this.addplantService
        .createPlantVegitation(uploadData)
        .subscribe((res) => {
          this.router.navigate(['/listplants/']);
        });
    } else {
      this.myForm.markAllAsTouched();
    }
  }

  removeImage(i: any) {
    console.log(i);
    this.images.splice(i, 1);
  }

  closeModal() {
    this.imageChangedEvent = null;
    this.modalService.dismissAll();
  }

  openModal(content: any, imgId: any) {
    this.cropImage(imgId + 1);
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'lg',
      })
      .result.then(
        (result) => {
          // this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  //get a Image using Image Id to crop
  //cropping process done here
  cropImage(imgId: any) {
    this.currentProcessingImg = imgId - 1;
    var imgObj = this.images[imgId - 1];

    //created dummy event Object and set as imageChangedEvent so it will set cropper on this image
    var event = {
      target: {
        files: [imgObj.imgFile],
      },
    };
    this.imageChangedEvent = event;
  }

  //Save Cropped Image locally
  SaveCropedImage() {
    this.images[this.currentProcessingImg].imgBase64 = this.croppedImage;
    this.images[this.currentProcessingImg].cropped = true;
    this.closeModal();
    // var imgObj = this.images[this.currentProcessingImg];
    // imgObj.imgBase64 = this.croppedImage;
    // this.finalImageList.push(imgObj.imgBase64);
    console.log('modal close', this.images);
  }

  /* SaveAllImages() {
    this.finalImageList = [];
    this.images.forEach((imgObject) => {
      this.finalImageList.push(imgObject.imgBase64);
    });
  } */

  imageCropped(event: ImageCroppedEvent) {
    console.log(event);
    this.croppedImage = event.base64;
  }

  imageLoaded() {
    // show cropper
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  dataURLtoFile(dataurl: string, filename: any) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename.split('?').at(0), { type: mime });
  }

  //api calls
  getParkDetails() {
    this.plantService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  goToBulkUploadPage() {
    this.router.navigate(['/bulk-upload/']);
  }
}
